import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'

export class Padding extends React.PureComponent<Padding.Props, Padding.State> {
  public static sectionId = 'padding';
  
  public render(): JSX.Element {
    const { settings } = this.props.section
    const { paddingSize, backgroundColor } = settings
    let paddingClass = ''
    
    switch (paddingSize) {
    case 'small':
      paddingClass = 'pb-2-4'
      break
    case 'medium':
      paddingClass = 'pb-6'
      break
    case 'large':
      paddingClass = 'pb-10'
      break
    }
    
    return (
      <section className={'dynamic-padding'}>
        <div className={`w-full h-0 ${paddingClass} ${settings.backgroundColor ? ' bg-core-pale' : ''}`}></div>
      </section>
    )
  }
}

export namespace Padding {
  export interface Options extends ShopifyNext.Section<{
    paddingSize: string;
    backgroundColor: boolean;
  }> { }
  export interface Props extends GlobalProps {
    section: Padding.Options;
  }
  export interface State { }
}